import { defineStore } from 'pinia';
import { api } from '../api/client';

/** Optional home sections the admin can hide (CMS → Homepage). */
export interface HomeSections { topProducts: boolean; howItWorks: boolean; whyUs: boolean; articles: boolean }

interface PublicFlags {
  kycDisabled: boolean;
  googleTagIds: string[];
  homeSections: HomeSections;
}

interface State {
  flags: PublicFlags;
  initialized: boolean;
}

export const useSettingsStore = defineStore('settings', {
  state: (): State => ({
    // Sections default to shown so nothing flickers away before /settings/public answers.
    flags: { kycDisabled: false, googleTagIds: [], homeSections: { topProducts: true, howItWorks: true, whyUs: true, articles: true } },
    initialized: false,
  }),
  getters: {
    kycDisabled: (s) => s.flags.kycDisabled,
  },
  actions: {
    async fetch() {
      try {
        const { data } = await api.get<PublicFlags>('/settings/public');
        this.flags = { ...this.flags, ...data };
      } catch {
        // Keep defaults — KYC remains enabled if the endpoint can't be reached.
      } finally {
        this.initialized = true;
      }
    },
  },
});
